import { Preview } from "../../../types/IAction";
import * as actions from "../../actions/horariosClubesActions";

export interface HorariosClubesDispatcher {
  getConfiguracionesHorariosClubes: () => Promise<Preview<any>>;
  getMantenimientos: () => Promise<Preview<any>>;
  getClubes: () => Promise<Preview<any>>;
  crearConfiguracionesHorariosClubes: (data: any) => Promise<Preview<any>>;
  actualizarConfiguracionesHorariosClubes: (
    id: string,
    data: any
  ) => Promise<Preview<any>>;
  eliminarConfiguracionesHorariosClubes: (id: string) => Promise<Preview<any>>;
}

export const horariosClubesDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => HorariosClubesDispatcher = dispatch => ({
  getConfiguracionesHorariosClubes: () => {
    return dispatch(actions.getConfiguracionesHorariosClubes());
  },
  getMantenimientos: () => {
    return dispatch(actions.getMantenimientos());
  },
  getClubes: () => {
    return dispatch(actions.getClubes());
  },
  crearConfiguracionesHorariosClubes: (data: any) => {
    return dispatch(actions.crearConfiguracionesHorariosClubes(data));
  },
  actualizarConfiguracionesHorariosClubes: (id: string, data: any) => {
    return dispatch(actions.actualizarConfiguracionesHorariosClubes(id, data));
  },
  eliminarConfiguracionesHorariosClubes: (id: string) => {
    return dispatch(actions.eliminarConfiguracionesHorariosClubes(id));
  }
});
